import React from 'react';
import { format } from 'date-fns';
import { CURRENCY_USD } from 'constants/currency';
import { getVideoAnalysisPageUrl } from 'constants/pages';
import { convertUnitPriceToFormattedPrice } from 'utils/shared/money/convertUnitPriceToFormattedPrice';
import Link from 'components/Link';
import CardNotification from './CardNotification';
import { PlayerVideoAnalysisNotificationTemplateProps } from '../types';

export default function PlayerVideoAnalysisNotificationTemplate({
  status,
  actorFullName,
  badgeComponent,
  message,
  videoAnalysis,
  showLessonPrice = false,
}: PlayerVideoAnalysisNotificationTemplateProps) {
  const [initialStatus] = React.useState(status);

  const formattedLessonPrice = convertUnitPriceToFormattedPrice(
    videoAnalysis?.orders[0]?.orderSubtotalUnitAmount || 0,
    videoAnalysis?.currency ||
      videoAnalysis?.videoAnalysisReviewer?.stripeMerchantCurrency ||
      videoAnalysis?.videoAnalysisReviewer?.currencyCoachDefault ||
      CURRENCY_USD,
  );

  // Add the price sentence to the message if showLessonPrice is true
  const finalMessage = `${message}${
    showLessonPrice && formattedLessonPrice?.priceDisplay
      ? ` You will receive ${formattedLessonPrice.priceDisplay} once you complete this review!`
      : ''
  }`;

  return (
    <Link href={getVideoAnalysisPageUrl(videoAnalysis?.id)} className="block">
      <CardNotification status={initialStatus}>
        <div className="p-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-bold">Video Analysis</span> {/* Title on top */}
            {badgeComponent}
          </div>

          {/* Display the final message with or without the price sentence */}
          <div className="mt-1 text-xs leading-5">{finalMessage}</div>

          <div className="flex gap-2 text-xs">
            <span className="text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
              Submitted on
            </span>
            {videoAnalysis?.createdAt && (
              <span className="text-color-brand-primary">
                {format(new Date(videoAnalysis?.createdAt), 'MMM d')}
              </span>
            )}
          </div>
        </div>
      </CardNotification>
    </Link>
  );
}
